// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__sceOB","loginCenter":"Login_loginCenter__zrKeH","loginLogo":"Login_loginLogo__JbUs7"};